<template>
  <div>
    <input
      type="text"
      class="id-daterange form-control"
      name="datetimes"
      autocomplete="off"
      :placeholder="$t('common.dateCreate')"
      @input="inputDateRangePicker()"
      v-model="dateRangePicker"
    />
  </div>
</template>

<script>
import "bootstrap-daterangepicker";
import moment from "moment";
import utils from "@/lib/utils";

export default {
  name: "DateRangePicker",
  props: ["dateFormat", "startDate", "endDate", "dateFormatEmit"],
  data() {
    return {
      dateRangePicker: null
    };
  },
  computed: {
    getStartDate: function() {
      let result = moment();
      if (utils.isEmptyString(this.startDate)) {
        return result;
      } else {
        result = this.startDate;
      }
      return result;
    },
    getEndDate: function() {
      let result = moment().add(1, "days");
      if (utils.isEmptyString(this.endDate)) {
        return result;
      } else {
        result = this.endDate;
      }
      return result;
    },
    getDateFormatEmit: function() {
      let result = "YYYY-MM-DD";
      if (!utils.isEmptyString(this.dateFormatEmit)) {
        result = this.dateFormatEmit;
      }
      return result;
    },
    getDateFormat: function() {
      let result = "DD/MM/YYYY";
      if (!utils.isEmptyString(this.dateFormat)) {
        result = this.dateFormat;
      }
      return result;
    },
  },
  methods: {
    emitApplyDatePicker: function(startDate, endDate) {
      let start = startDate.format(this.getDateFormatEmit);
      let end = endDate.format(this.getDateFormatEmit);
      this.$emit("applyDatePicker", { start_date: start, end_date: end });
    },
    emitClearDatePicker: function() {
      this.$emit("clearDatePicker", { start_date: null, end_date: null });
    },
    inputDateRangePicker: function() {
      if (utils.isEmptyString(this.dateRangePicker)) {
        this.emitClearDatePicker()
      }
    }
  },
  mounted() {
    var self = this;
    $('input[name="datetimes"]').daterangepicker({
      startDate: this.getStartDate,
      endDate: this.getEndDate,
      autoUpdateInput: false,
      locale: {
        format: self.getDateFormat,
        cancelLabel: "Clear"
      }
    });
    $('input[name="datetimes"]').on("apply.daterangepicker", function(
      ev,
      picker
    ) {
      // $(this).val(
      //   picker.startDate.format(self.getDateFormat) +
      //     " - " +
      //     picker.endDate.format(self.getDateFormat)
      // );
      let dateRangePicker = picker.startDate.format(self.getDateFormat) +
        " - " +
        picker.endDate.format(self.getDateFormat)
      self.dateRangePicker = dateRangePicker
      self.emitApplyDatePicker(picker.startDate, picker.endDate);
    });

    $('input[name="datetimes"]').on("cancel.daterangepicker", function(
      ev,
      picker
    ) {
      $(this).val("");
      self.emitClearDatePicker()
      self.dateRangePicker = null
    });
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/LTEDateRangePickerCustom.vue